// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* In Accordion.module.css */

.Accordion_accordionContainer__3zLNx {
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fafbfc;
  position: relative;
}

.Accordion_accordionHeader__0bGU4 {
  box-sizing: border-box;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 16px 20px;
  font-weight: 600;
  font-size: 1.1rem;
  color: var(--primary-dark-blue);
  cursor: pointer;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: flex-start;
}

.Accordion_accordionTitleGroup__QBXkI {
  display: flex;
  align-items: center;
  gap: 10px;
}

.Accordion_accordionButton__VjxLD {
  position: absolute;
  top: 14px;
  right: 50px;
  z-index: 10;

  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: var(--secondary-bright-blue);
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
}

.Accordion_accordionButton__VjxLD:hover {
  color: var(--primary-dark-blue);
}

.Accordion_accordionChildren__cCSNV {
  padding: 0 20px 16px 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Accordion/Accordion.module.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;;EAEX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* In Accordion.module.css */\n\n.accordionContainer {\n  border: 1px solid #eee;\n  border-radius: 8px;\n  background: #fafbfc;\n  position: relative;\n}\n\n.accordionHeader {\n  box-sizing: border-box;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  padding: 16px 20px;\n  font-weight: 600;\n  font-size: 1.1rem;\n  color: var(--primary-dark-blue);\n  cursor: pointer;\n  outline: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.accordionTitleGroup {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.accordionButton {\n  position: absolute;\n  top: 14px;\n  right: 50px;\n  z-index: 10;\n\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: var(--secondary-bright-blue);\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.accordionButton:hover {\n  color: var(--primary-dark-blue);\n}\n\n.accordionChildren {\n  padding: 0 20px 16px 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordionContainer": `Accordion_accordionContainer__3zLNx`,
	"accordionHeader": `Accordion_accordionHeader__0bGU4`,
	"accordionTitleGroup": `Accordion_accordionTitleGroup__QBXkI`,
	"accordionButton": `Accordion_accordionButton__VjxLD`,
	"accordionChildren": `Accordion_accordionChildren__cCSNV`
};
export default ___CSS_LOADER_EXPORT___;
